import { Col, Row } from "reactstrap";
import { GetLanguageString } from "../../../helper/Components";
import { GetSelectedLanguage } from "../../../helper/Method";

const formatAmount = (value) =>
  new Intl.NumberFormat().format(Number(value) || 0);

const BalanceCard = ({
  titleKey,
  badgeKey,
  opening,
  closing,
  gradient,
  icon,
}) => {
  const urClass = GetSelectedLanguage() === "ur" ? "ur" : "";

  return (
  <Col md="6" className="mb-3">
    <div
      style={{
        background: gradient,
        color: "#ffffff",
        padding: "16px 18px",
        borderRadius: "14px",
        boxShadow: "0 8px 24px rgba(22, 55, 60, 0.14)",
        border: "1px solid rgba(255, 255, 255, 0.14)",
        minHeight: "118px",
        height: "100%",
        transition: "all 0.25s ease-in-out",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-2px)";
        e.currentTarget.style.boxShadow = "0 12px 28px rgba(22, 55, 60, 0.2)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "0 8px 24px rgba(22, 55, 60, 0.14)";
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "14px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          {icon}
          <span
            className={urClass}
            style={{
              fontSize: "14px",
              fontWeight: 700,
            }}
          >
            <GetLanguageString props={titleKey} />
          </span>
        </div>
        <span
          className={urClass}
          style={{
            background: "rgba(255, 255, 255, 0.14)",
            border: "1px solid rgba(255, 255, 255, 0.18)",
            borderRadius: "999px",
            fontSize: "10px",
            fontWeight: 600,
            padding: "2px 10px",
          }}
        >
          <GetLanguageString props={badgeKey} />
        </span>
      </div>
      <Row>
        <Col xs="6">
          <div
            className={urClass}
            style={{
              fontSize: "11px",
              opacity: 0.85,
              marginBottom: "4px",
            }}
          >
            <GetLanguageString props="income_report_opening_balance" />
          </div>
          <div style={{ fontSize: "20px", fontWeight: 800, letterSpacing: "-0.3px" }}>
            Rs {formatAmount(opening)}
          </div>
        </Col>
        <Col xs="6">
          <div
            className={urClass}
            style={{
              fontSize: "11px",
              opacity: 0.85,
              marginBottom: "4px",
            }}
          >
            <GetLanguageString props="income_report_closing_balance" />
          </div>
          <div style={{ fontSize: "20px", fontWeight: 800, letterSpacing: "-0.3px" }}>
            Rs {formatAmount(closing)}
          </div>
        </Col>
      </Row>
    </div>
  </Col>
  );
};

const cashIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ opacity: 0.95 }}
  >
    <path d="M20 12V8H6a2 2 0 0 1-2-2c0-1.1.9-2 2-2h12v4" />
    <path d="M4 6v12a2 2 0 0 0 2 2h14v-4" />
    <path d="M18 12a2 2 0 0 0 0 4h4v-4z" />
  </svg>
);

const amanatIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ opacity: 0.95 }}
  >
    <path d="M3 21h18M3 10h18M5 6l7-3 7 3M4 10v11M20 10v11M8 14v3M12 14v3M16 14v3" />
  </svg>
);

const IncomeReportBalances = ({ cashInHand, amanat }) => {
  if (!cashInHand?.configured && !amanat?.configured) {
    return null;
  }

  return (
    <Row className="mb-3 align-items-stretch">
      {cashInHand?.configured ? (
        <BalanceCard
          titleKey="income_report_cash_in_hand"
          badgeKey="cash_in_hand_account"
          opening={cashInHand.openingBalance}
          closing={cashInHand.closingBalance}
          gradient="linear-gradient(135deg, #486A84 0%, #39576B 45%, #2D4455 100%)"
          icon={cashIcon}
        />
      ) : null}
      {amanat?.configured ? (
        <BalanceCard
          titleKey="income_report_amanat"
          badgeKey="amanat_account"
          opening={amanat.openingBalance}
          closing={amanat.closingBalance}
          gradient="linear-gradient(135deg, #35A08E 0%, #237A6E 45%, #1B6258 100%)"
          icon={amanatIcon}
        />
      ) : null}
    </Row>
  );
};

export default IncomeReportBalances;
